import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET = apiPromiseTypes('linkedMembership', 'get');
